import { useParams, Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs, BreadcrumbsLink, BreadcrumbsSpan } from '@bn-apps/design-system-ui-react';
import { Container, PageHeader } from '@bn-apps/dim-ui-react';
import HelpContent from './HelpContent';
import routes from '@config/routes';
import helpStyles from './HelpDetailPage.module.scss';
import appStyles from '@/App.module.scss';


const HelpDetailPage = (): JSX.Element => {
    const { t } = useTranslation();
    const { section } = useParams<{ section: string }>();

    // Map URL params to section IDs
    const sectionMap: Record<string, string> = {
        'getting-started': 'gettingStarted',
        'authentication': 'authentication',
        'files': 'files',
        'datasets': 'datasets',
        'map': 'map',
        'tools': 'tools',
        'reports': 'reports',
        'accessibility': 'accessibility',
        'data-lineage': 'dataLineage',
        'data-catalog': 'dataCatalog',
        'tps-mapping': 'tpsMapping',
        'dereferencing': 'dereferencing',
        'definitions': 'definitions',
        'support': 'support',
    };

    const sectionId = section ? sectionMap[section] || 'gettingStarted' : 'gettingStarted';

    return (
        <Container className={appStyles.pageContent}>
            <Breadcrumbs>
                <BreadcrumbsLink asChild className={helpStyles.breadCrumbsLink}>
                    <RouterLink to={routes.help}>{t('help.title')}</RouterLink>
                </BreadcrumbsLink>
                <BreadcrumbsSpan currentPage>
                    {t(`help.${sectionId}`)}
                </BreadcrumbsSpan>
            </Breadcrumbs>

            <div className="bn-mbe-800">
                <PageHeader title={t(`help.${sectionId}`)} />
            </div>

            <div className="bn-mbs-800">
                <HelpContent section={sectionId} />
            </div>
        </Container>
    );
};

export default HelpDetailPage;
